exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".beam{display:inline-block;height:20px;background-color:#2e2e2e;color:#fff;min-width:10px;-webkit-transform-origin:left center;transform-origin:left center;-webkit-animation:bounce-scale .7s ease-in-out}@-webkit-keyframes bounce-scale{0%{-webkit-transform:scalex(.01);transform:scalex(.01)}to{-webkit-transform:scalex(1);transform:scalex(1)}}@keyframes bounce-scale{0%{-webkit-transform:scalex(.01);transform:scalex(.01)}to{-webkit-transform:scalex(1);transform:scalex(1)}}.option{line-height:20px;margin-top:5px}.option-text{color:#2e2e2e}.percentage{padding:3px 5px}.poll{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);background-color:#fff;min-height:100px;padding:0}.poll-container{overflow:hidden;margin:20px}.disclaimer{color:#a9a9a9;font-style:italic}.score{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}header{padding:20px;margin:10px 0;border-bottom:1px solid #ddd;position:relative}h2{font-size:150%;margin:0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/poll/poll.component.css
// module id = 501
// module chunks = 1